<script>

</script>


<div on:click={() => window.open("mailto:ashar562@uwo.ca")}>
    <img alt="outlook" src="outlook.png">
    <a target="_blank" href="mailto:ashar562@uwo.ca">Mail</a>
</div>


<style>
    a {
        font-weight: bold;
        text-decoration: none;
        color: white;
        margin-right: 0;
    }

    div {
        background-size: 1.5em;
        background: #005ea2;
        border-radius: 30px;
        padding: 0 15px;
        width: 75px;
        height: 35px;
        line-height: 2;
        display: flex;
        justify-content: right;
    }

    div:hover {
        background-color: #002844FF;
    }

    img {
        justify-content: left;
        margin-right: 19px;
    }

</style>